import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import DeclaracionJuradaCeseActividadDirecta from './DeclaracionJuradaCeseActividadDirecta';
import useGetDeclaracionJuradaCeseActividadDirectaByID from 'services/record/DeclaracionJuradaCeseActividadDirecta/useGetDeclaracionJuradaCeseActividadDirectaByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialDeclaracionJuradaCeseActividadDirecta = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetDeclaracionJuradaCeseActividadDirectaByID, errorGetDeclaracionJuradaCeseActividadDirectaByID, getDeclaracionJuradaCeseActividadDirectaByID, loadingGetDeclaracionJuradaCeseActividadDirectaByID, successGetDeclaracionJuradaCeseActividadDirectaByID } = useGetDeclaracionJuradaCeseActividadDirectaByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getDeclaracionJuradaCeseActividadDirectaByID(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Declaración jurada cese definitivo por motivos económicos, técnicos y productivos de Estimación directa'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetDeclaracionJuradaCeseActividadDirectaByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <DeclaracionJuradaCeseActividadDirecta dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialDeclaracionJuradaCeseActividadDirecta